import { render, staticRenderFns } from "./ClientFormDefault.vue?vue&type=template&id=51d6658a&"
import script from "./ClientFormDefault.vue?vue&type=script&lang=js&"
export * from "./ClientFormDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports